//@ts-check
import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";

// Components
import { ga } from "../scripts";
import Layout from "../components/layout";

// Assets
import logo from "../assets/images/logo.png";
import skip from "../assets/images/skip.png";
import doordash from "../assets/images/doordash.png";
import uber from "../assets/images/uber.png";
import tutti from "../assets/images/tutti.png";
import global from "../pages/general.module.css";
import inputs from "../components/inputs.module.css";
import favicon from "../assets/images/favicon.ico";
import styles from "../components/navigation.module.css";
import textStyles from "../components/most-recent.module.css";
import { useRestaurantsData } from "../context/restaurants";
import { useState } from "react";
import { useWebAds } from "../context/ads";

const CovidIndex = () => {
  const { edges } = useRestaurantsData();
  const { ads } = useWebAds();
  const [filter, setFilter] = useState("");
  const [search, setSearch] = useState("");

  let posts = edges;

  const searchInputChanged = (e) => {
    setSearch(e.target.value);
  };

  if (filter === "delivery") {
    posts = edges.filter((r) => r.node.delivery);
  }

  if (filter === "takeOut") {
    posts = edges.filter((r) => r.node.takeOut);
  }

  if (search) {
    posts = posts.filter((r) =>
      r.node.name.toUpperCase().includes(search.toUpperCase())
    );
  }

  const analyticEvent = (category, action) => {
    const gtag = window.gtag || null;

    if (!ga) return;

    gtag('event', 'click', {
      'event_category': category,
      'event_label': action,
      'value': 1
    })

  }

  const getDeliveryButton = (restaurant) => {
    if (restaurant.skipTheDishes) {
      return <a onClick={() => analyticEvent('skip', restaurant.name)} href={restaurant.skipTheDishes} target="_blank" rel="noopener noreferrer">
        <img alt="" className={global.deliveryButton} src={skip} />
      </a>
    } else if (restaurant.doordash) {
      return <a onClick={() => analyticEvent('doordash', restaurant.name)} href={restaurant.doordash} target="_blank" rel="noopener noreferrer">
        <img alt="" className={global.deliveryButton} src={doordash} />
      </a>
    } else if (restaurant.uberEats) {
      return <a onClick={() => analyticEvent('uber', restaurant.name)} href={restaurant.uberEats} target="_blank" rel="noopener noreferrer">
        <img alt="" className={global.deliveryButton} src={uber} />
      </a>
    } else if (restaurant.tutti) {
      return <a onClick={() => analyticEvent('tutti', restaurant.name)} href={restaurant.tutti} target="_blank" rel="noopener noreferrer">
        <img alt="" className={global.deliveryButton} src={tutti} />
      </a>
    }
  }


  return (
    <Layout>
      <div style={{ background: "#f7f7f7", padding: "0px 0px" }}>
        <Helmet title={`Restaurant Directory - Tasting Victoria`}>
          <link rel="icon" href={favicon} type="image/x-icon" />

          <meta
            property="og:title"
            content={`Victoria Restaurants Directory - Tasting Victoria`}
          />
          <meta
            property="og:description"
            content={`A comprehensive list of restaurants that are currently open for take-out and delivery in Victoria, BC.`}
          />
          <meta
            property="og:image"
            content={`//images.ctfassets.net/evh3vlaprvno/5XVWvVglPFRlMk6Pu8XwdS/487082eccc0e4d26c25416113e9a2a1d/Screen_Shot_2020-03-20_at_2.37.16_PM.png?w=400&q=50`}
          />

          {/* <!-- Global site tag (gtag.js) - Google Analytics --> */}
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=UA-158051086-1"
          ></script>
          <script>{ga}</script>

          <script type="text/javascript" src="https://a.omappapi.com/app/js/api.min.js" data-account="121742" data-user="109831" async></script>
        </Helmet>

        <nav role="navigation">
          <ul
            style={{
              height: "auto",
              paddingBottom: "18px",
              position: "fixed",
              top: "0",
              left: "0",
            }}
            className={styles.navigation}
          >
            <div
              className={styles.container}
              style={{ display: "flex", justifyContent: "flex-start" }}
            >
              <Link to="/">
                <img src={logo} alt="logo" className={styles.logo} style={{ width: "36px", height: "36px" }} />
              </Link>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginLeft: "34px",
                  width: "inherit",
                  maxWidth: "890px",
                }}
              >
                <input
                  className={`${inputs.text}`}
                  placeholder={`Search for Restaurant`}
                  onChange={(e) => {
                    searchInputChanged(e);
                  }}
                />
                <div className={`${global.navFilter}`}>
                  <div
                    className={`${global.filter} ${
                      filter === "" && global.filterSelected
                      }`}
                    onClick={() => setFilter("")}
                  >
                    All
                  </div>

                  <div
                    className={`${global.filter} ${
                      filter === "delivery" && global.filterSelected
                      }`}
                    onClick={() => setFilter("delivery")}
                  >
                    Delivery
                  </div>

                  <div
                    className={`${global.filter} ${
                      filter === "takeOut" && global.filterSelected
                      }`}
                    onClick={() => setFilter("takeOut")}
                  >
                    Take out
                  </div>
                </div>
              </div>
            </div>
          </ul>
        </nav>

        <div
          style={{ maxWidth: "920px", paddingTop: "128px", paddingBottom: "80px" }}
          className={`${global.container}`}
        >

          <div className={`${global.bodyFilter}`}>
            <div
              className={`${global.filter} ${
                filter === "" && global.filterSelected
                }`}
              onClick={() => setFilter("")}
            >
              All
                  </div>

            <div
              className={`${global.filter} ${
                filter === "delivery" && global.filterSelected
                }`}
              onClick={() => setFilter("delivery")}
            >
              Delivery
                  </div>

            <div
              className={`${global.filter} ${
                filter === "takeOut" && global.filterSelected
                }`}
              onClick={() => setFilter("takeOut")}
            >
              Take out
                  </div>
          </div>

          <div className={global.adContainer}>
            <div className={global.adOne}>
              <a onClick={() => analyticEvent("ads", "mod")} href={ads[1].node.link} target="_blank">
                <img src={ads[1].node.image.file.url} />
              </a>
            </div>

            <div className={global.adTwo}>
              <a onClick={() => analyticEvent("ads", "ferris")} href={ads[0].node.link} target="_blank">
                <img src={ads[0].node.image.file.url} />
              </a>
            </div>
          </div>



          <h1 className={textStyles.title}>
            Victoria Restaurants Directory
          </h1>
          <p style={{ marginTop: "0px", paddingBottom: "25px" }}>
            A comprehensive list of restaurants that are currently open for take-out and delivery in Victoria, BC.
          </p>



          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignContent: "stretch",
              alignItems: "flex-start",
            }}
          >
            {posts.map(({ node }) => {

              const hasDelivery = node.uberEats || node.tutti || node.skipTheDishes || node.doordash;

              return (
                <div key={node.id} className={`${global.restaurant} ${hasDelivery ? global.deliveryPadding : ''}`}>
                  <div style={{ display: "flex" }}>
                    <div className={global.restLogo}>

                      {node.logo &&
                        <img
                          id={node.logo.id}
                          src={node.logo.file.url}
                          style={{ maxHeight: "60px", maxWidth: "60px" }}
                          width="100%"
                        />
                      }

                    </div>
                    <div>
                      <h2
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          margin: "0px",
                          marginTop: "2px",
                          lineHeight: "1.2",
                        }}
                      >
                        {node.name}
                      </h2>
                      {node.delivery && (
                        <span className={global.greenBox}>Delivery</span>
                      )}

                      {node.delivery && node.takeOut && (
                        <span className={global.greenBox}>{"/  "}</span>
                      )}

                      {node.takeOut && (
                        <span className={global.greenBox}>Take out</span>
                      )}

                      {node.score == 1 && (
                        <span className={global.sponsoredPost}>Sponsored</span>
                      )}

                      {node.instagramHandle && (
                        <div style={{
                          marginTop: "-3px"
                        }}>
                          <a
                            style={{
                              fontSize: "14px",
                              textDecoration: "none",
                              color: "#85d2da",
                            }}
                            href={`https://instagram.com/${node.instagramHandle.replace(
                              "@",
                              ""
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {node.instagramHandle}
                          </a>
                        </div>
                      )}
                    </div>

                  </div>

                  {hasDelivery &&
                    <div className={global.deliveryContainer}>
                      <div
                        className={global.thirdParty}
                        style={{
                          marginTop: "4px"
                        }}
                      >Third-party delivery services</div>
                      {getDeliveryButton(node)}
                    </div>
                  }

                </div>
              );
            })}
          </div>

          <div>
            {posts.length == 0 &&
              <p style={{ textAlign: "center" }}>No results found.</p>
            }

            <br />
            <p style={{ textAlign: "center" }}>
              Want us to add your restaurant? <a style={{ color: "#85d2da" }} href="mailto:info@tastingvictoria.com">Let us know</a>
            </p>

            <p style={{ textAlign: "center" }}>
              <a style={{ color: "#85d2da" }} href="../">Visit our blog </a>
            </p>

          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CovidIndex;
